import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { FaShoppingCart } from "react-icons/fa";
import {
  FaCartPlus,

} from "react-icons/fa";
import { Ruler, Trash2 } from "lucide-react";
import { motion } from "framer-motion";
import { FaArrowLeft } from "react-icons/fa";

import { Link } from "react-router-dom";
import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import defaultImg from "../../../../assets/windTree/images/login/loginlogo.webp";
import "swiper/css";
import "swiper/css/navigation";
import RelatedProducts from "./components/RelatedProducts.jsx";
import { getInventoryDetailById } from "../../../redux/api/admin/InventoryApi.jsx";
import { getShadeDetailById } from "../../../redux/api/admin/shadeApi.jsx";
import {
  addToCartApi,
  deleteCartItem,
  deleteCartItemThunk,
} from "../../../redux/api/website/Addtocartapi";
import { fetchUserData } from "../../../redux/reduxApi/SingIn&SingUp/SinginApi.jsx";
import { toast } from "react-toastify";
import Shoploader from "../loader/Shoploader";
import Button from "../../../ui/Button.jsx";
import Heading from "../utils/Heading.jsx";
import Cookies from "js-cookie";
import {
 
  ModalCloseButton,
  StatDownArrow,
} from "@chakra-ui/react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button as ChakraButton,
  useDisclosure,
} from "@chakra-ui/react";
import {
  getCartProducts,
  getCartProductsWebuser,
} from "../../../redux/reduxApi/website/CartProductCount.jsx";
import { getShadeNumberList } from "../../../redux/reduxApi/admin/ShadeReduxApi.jsx";
import { getMotorsList } from "../../../redux/reduxApi/admin/MotorizationReduxApi.jsx";
import { getColoursList } from "../../../redux/reduxApi/admin/ColourReduxApi.jsx";
import { getTags } from "../../../redux/reduxApi/admin/TagReduxApi.jsx";

const ProductDetailPage = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const [isLoading, setIsLoading] = useState(false);
  const { id } = useParams();
  const [webUserId, setWebUserId] = useState("");
  const [cartItems, setCartItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const userId = localStorage.getItem("UserRowId");
  const accountId = localStorage.getItem("loggedCustomer");
  let guestId = Cookies.get("guest_id");
const [savedFormData, setSavedFormData] = useState(null);
  const getTagsData = useSelector((state) => state?.tags?.tags);

  useEffect(() => {
    const storedUserId = localStorage.getItem("UserRowId");
    setWebUserId(storedUserId);
    console.log("UserRowId from localStorage:", storedUserId);
    console.log("UserRowIdsm from localStorage:", storedUserId);
  }, []);

  useEffect(() => { }, [getTagsData]);

  useEffect(() => {
    const fetchTags = async () => {
      try {
        setLoading(true);
        await dispatch(getTags());
      } catch (error) {
        console.error("Error fetching tags data:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchTags();
  }, [dispatch]);

  const ratingData = {
    average: 4.5,
    totalRatings: 437,
    totalReviews: 47,
    breakdown: {
      5: 3100,
      4: 1400,
      3: 1000,
      2: 300,
      1: 300,
    },
  };

  const reviews = [
    {
      name: "Darrell Steward",
      date: "1 Feb, 2021",
      rating: 4.1,
      title: "Brilliant",
      content:
        "This is the best Macbook that Apple has ever made. It is also one of the best laptops in the world right now. Definitely go for it.",
      likes: 453,
      comments: 583,
      avatar: "https://randomuser.me/api/portraits/women/44.jpg",
    },
  ];

  const [rating, setRating] = useState(0);
  const [hover, setHover] = useState(null);
  const [review, setReview] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log({ rating, review });
    setRating(0);
    setReview("");
  };

  const cart = useSelector((state) => state.Cart.CartProducts || []);
  const [unit, setUnit] = useState("cm");
  const [height, setHeight] = useState("");
  const [width, setWidth] = useState("");
  const [shadeData, setShadeData] = useState({});
  console.log("shadeData", shadeData);
  const [selectedItem, setSelectedItem] = useState(null);
  const [area, setArea] = useState(0);
  const [priceBreakdown, setPriceBreakdown] = useState({
    subtotal: 0,
    taxAmount: 0,
    total: 0,
  });

  const shadeImages = React.useMemo(() => {
    try {
      if (shadeData?.shadeMedia) {
        return Array.isArray(shadeData.shadeMedia)
          ? shadeData.shadeMedia
          : [];
      }
    } catch (err) {
      console.error("Failed to parse shadeMedia:", err);
    }
    return [];
  }, [shadeData?.shadeMedia]);

  const itemImages = React.useMemo(() => {
    try {
      if (selectedItem?.itemImage) {
        const parsed = JSON.parse(selectedItem.itemImage);
        return Array.isArray(parsed) ? parsed : [];
      }
    } catch (err) {
      console.error("Failed to parse itemImage:", err);
    }
    return [];
  }, [selectedItem?.itemImage]);

  const displayImages = shadeImages.length > 0 ? shadeImages : itemImages;

  useEffect(() => {
    let isMounted = true;
    if (id) {
      setIsLoading(true);
      getShadeDetailById(id)
        .then((response) => {
          if (isMounted && response?.data?.data?.shade) {
            const shadeData = response?.data?.data?.shade;
            setShadeData(shadeData);
            if (shadeData.items && shadeData.items.length > 0) {
              setSelectedItem(shadeData.items[0]);
            }
          }
        })
        .catch((error) => {
          console.error("Error fetching shade details:", error);
          if (isMounted) {
            toast({
              title: "Error fetching shade details",
              status: "error",
              duration: 3000,
              isClosable: true,
            });
          }
        })
        .finally(() => {
          if (isMounted) {
            setIsLoading(false);
          }
        });
    }
    return () => {
      isMounted = false;
    };
  }, [id]);

  const [imageIndex, setImageIndex] = useState(0);
  const [quantity, setQuantity] = useState(1);
  const [quantities, setQuantities] = useState({});
  const [motorization, setMotorization] = useState("No");
  const [sideOfControl, setSideOfControl] = useState("Right");
  const [remarks, setRemarks] = useState("");
  const [motorType, setMotorType] = useState("");

  const handleIncrease = () => setQuantity((prev) => prev + 1);
  const handleDecrease = () => setQuantity((prev) => (prev > 1 ? prev - 1 : 1));
  const changeImage = (idx) => setImageIndex(idx);

  const [motorData, setMotorData] = useState([]);
  console.log("motorData", motorData);
  const [searchQuery, setSearchQuery] = useState(null);
// Restore form data after login redirect
useEffect(() => {
  const pendingData = localStorage.getItem('pendingProductData');
  const redirectPath = localStorage.getItem('redirectAfterLogin');
  
  if (pendingData && userId && window.location.pathname === redirectPath) {
    try {
      const savedData = JSON.parse(pendingData);
      
      // Restore all form values
      setHeight(savedData.height || "");
      setWidth(savedData.width || "");
      setUnit(savedData.unit || "cm");
      setQuantity(savedData.quantity || 1);
      setMotorization(savedData.motorization || "No");
      setSideOfControl(savedData.sideOfControl || "Right");
      setMechanismColor(savedData.mechanismColor || "white");
      setRemarks(savedData.remarks || "");
      setMotorType(savedData.motorType || "");
      
      // Restore selected item
      if (savedData.selectedItemId && shadeData.items) {
        const restoredItem = shadeData.items.find(item => item.ROWID === savedData.selectedItemId);
        if (restoredItem) {
          setSelectedItem(restoredItem);
        }
      }
      
      // Clear the saved data after restore
      localStorage.removeItem('pendingProductData');
      localStorage.removeItem('redirectAfterLogin');
      
      // Show success message
      toast.success("Your customization has been restored! Click Add to Cart when ready.");
      
    } catch (error) {
      console.error("Error restoring form data:", error);
    }
  }
}, [userId, shadeData.items, window.location.pathname]);
  useEffect(() => {
    const payload = searchQuery;
    dispatch(getMotorsList(payload))
      .then((res) => {
        const list = res?.payload?.data?.motors || [];
        setMotorData(list);
      })
      .catch((err) => {
        console.error("Error fetching motors:", err);
        toast.error("Failed to fetch motors");
      })
      .finally(() => {
        setLoading(false);
      });
  }, [dispatch]);

  // Width × Drop in Inch → Square Metres
  const inchesToSqM = (widthInch, dropInch) => {
    if (dropInch === 0) {
      return 0;
    }

    const areaSqInch =
      (widthInch * Math.max(39.37, dropInch)) / 144;

    return Math.max(areaSqInch, 10.764) / 10.76;
  };

  // Width × Drop in Millimetres → Square Metres
  const mmToSqM = (widthMm, dropMm) => {
    if (dropMm === 0) {
      return 0;
    }

    const effectiveDrop = dropMm < 1000 ? 1000 : dropMm;

    // mm² → m²
    const areaSqM = widthMm * effectiveDrop * 0.000001;

    // Keep the existing minimum area rule
    return areaSqM < 1 ? 1 : areaSqM;
  };

  // Width × Drop in Centimetres → Square Metres
  const cmToSqM = (widthCm, dropCm) => {
    if (dropCm === 0) {
      return 0;
    }

    const effectiveDrop = dropCm < 100 ? 100 : dropCm;

    // cm² → m²
    const areaSqM = widthCm * effectiveDrop * 0.0001;

    // Keep the existing minimum area rule
    return areaSqM < 1 ? 1 : areaSqM;
  };

  const calculateAmount = (area, qty, rate) => {
    const a = Number(area) || 0;
    const q = Number(qty) || 0;
    const r = Number(rate) || 0;
    const subtotal = a * q * r;
    return {
      subtotal: Number(subtotal.toFixed(2)),
      total: Number(subtotal.toFixed(2)),
    };
  };

  const calculateArea = (heightValue, widthValue, unit) => {
    const h = Number(heightValue) || 0;
    const w = Number(widthValue) || 0;
    if (h <= 0 || w <= 0) return 0;
    let calculatedArea = 0;
    switch (unit) {
      case "inch":
        calculatedArea = inchesToSqM(w, h);
        break;
      case "mm":
        calculatedArea = mmToSqM(w, h);
        break;
      case "cm":
        calculatedArea = cmToSqM(w, h);
        break;
      default:
        calculatedArea = 0;
    }
    console.log("calculatedArea", calculatedArea);
    return calculatedArea;
  };

  useEffect(() => {
    if (height && width && unit) {
      const calculatedArea = calculateArea(height, width, unit);
      setArea(calculatedArea);
    } else {
      setArea(0);
    }
  }, [height, width, unit]);

  useEffect(() => {
    if (selectedItem && area > 0 && quantity > 0) {
      const itemPrice = parseFloat(selectedItem?.sellingPrice) || 0;
      const breakdown = calculateAmount(area, quantity, itemPrice);
      setPriceBreakdown(breakdown);
    } else {
      setPriceBreakdown({ subtotal: 0, total: 0 });
    }
  }, [area, quantity, selectedItem]);

  const totalPrice = priceBreakdown.total;
  const [finalPrice, setFinalPrice] = useState(0);

  useEffect(() => {
    const itemPrice = parseFloat(selectedItem?.sellingPrice) || 0;
    const shadePrice = parseFloat(shadeData?.sellingPrice) || 0;

    const rate = itemPrice + shadePrice;

    const baseTotal = area * rate * quantity;
    let motorTotal = 0;
    if (motorization === "Yes" && motorType) {
      console.log("motortype", motorType);
      const selectedMotor = motorData.find((m) => m.motorName === motorType);
      const motorPrice = parseFloat(selectedMotor?.motorPrice) || 0;
      console.log("motor price", motorPrice);
      motorTotal = motorPrice * quantity;
    }
    const total = baseTotal + motorTotal;
    setFinalPrice(total);
  }, [
    area,
    selectedItem?.sellingPrice,
    quantity,
    motorization,
    motorType,
    motorData,
  ]);

  const handleItemChange = (itemId) => {
    const selected = shadeData.items.find((item) => item.ROWID === itemId);
    if (selected) {
      setSelectedItem(selected);
      setQuantity(1);
    }
  };
      console.log("window.location.pathname",window.location.hash);


  // const handleAddToCart = async (e) => {
  //   e.stopPropagation();
  //   if (!userId) {
  //     toast.error("You are not logged in.");
  //     navigate("/login");
  //     return;
  //   }
  //   if (!selectedItem) {
  //     toast.error("Please select a product item first");
  //     return;
  //   }
  //   if (!height || !width) {
  //     toast.error("Please enter height and width");
  //     return;
  //   }
  //    // Add width validation before adding to cart
  // const widthValue = parseFloat(width);
  // const minWidth = getMinWidthInCurrentUnit();
  // const maxWidthMM = shadeData?.maxWidth ? parseFloat(shadeData.maxWidth) : null;
  
  // // Check min width
  // if (widthValue < minWidth) {
  //   toast.error(`Width must be at least ${minWidth} ${unit}`);
  //   return;
  // }
  
  // // Check max width if available
  // if (maxWidthMM) {
  //   let valueInMM = widthValue;
  //   switch (unit) {
  //     case "cm":
  //       valueInMM = widthValue * 10;
  //       break;
  //     case "inch":
  //       valueInMM = widthValue * 25.4;
  //       break;
  //   }
  //   if (valueInMM > maxWidthMM) {
  //     let maxInCurrentUnit = maxWidthMM;
  //     switch (unit) {
  //       case "cm":
  //         maxInCurrentUnit = (maxWidthMM / 10).toFixed(1);
  //         break;
  //       case "inch":
  //         maxInCurrentUnit = (maxWidthMM / 25.4).toFixed(2);
  //         break;
  //       default:
  //         maxInCurrentUnit = maxWidthMM;
  //     }
  //     toast.error(`Width cannot exceed ${maxInCurrentUnit} ${unit}`);
  //     return;
  //   }
  // }
  
  //   const selectedMotor = motorData.find((m) => m.motorName === motorType);
  //   const motorRowId = selectedMotor?.ROWID || "";
  //   const taxRate = selectedItem?.tax ? Number(selectedItem.tax) : 0;
  //   const itemPrice = parseFloat(selectedItem?.sellingPrice) || 0;
  //   const shadePrice = parseFloat(shadeData?.sellingPrice) || 0;
  //   const sellingPrice = itemPrice + shadePrice;
  //   const calculatedArea = calculateArea(height, width, unit) || 0;
  //   const newCartData = {
  //     accountId: userId || null,
  //     productId: selectedItem?.ROWID || "",
  //     quantity: quantity.toString(),
  //     price: sellingPrice.toString(),
  //     shadeNo: shadeData?.shadeNo || "Product",
  //     itemName: selectedItem?.itemName || "",
  //     image: displayImages[0] || defaultImg,
  //     height: height.toString(),
  //     width: width.toString(),
  //     unit: unit,
  //     measurements: unit,
  //     status: "Active",
  //     motorization: motorization,
  //     sideOfControl: sideOfControl,
  //     mechanismColor: mechanismColor,
  //     remarks: remarks,
  //     area: calculatedArea.toString(),
  //     taxRate: taxRate.toString(),
  //     subtotal: priceBreakdown.subtotal.toString(),
  //     sellingPricePerUnit: sellingPrice.toString(),
  //     motorType: motorRowId,
  //     total: finalPrice.toString(),
  //   };

  //   try {
  //     const response = await addToCartApi(newCartData);
  //     if (response.data.success) {
  //       toast.success("Product added to cart successfully");
  //       const resp = await dispatch(getCartProductsWebuser());
  //       const carts = resp?.payload?.data || [];
  //       setCartItems(carts);
  //       setAddedProducts((prev) => {
  //         const updated = [...prev, newCartData];
  //         localStorage.setItem("addedProducts", JSON.stringify(updated));
  //         return updated;
  //       });
  //       onOpen();
  //     }
  //   } catch (error) {
  //     console.error("Error adding product to cart:", error);
  //     toast.error(error.response?.data?.message || "Failed to add to cart");
  //   }
  // };
const handleAddToCart = async (e) => {
  e.stopPropagation();
  
  // Save current form data before login check
  const currentFormData = {
    height,
    width,
    unit,
    quantity,
    motorization,
    sideOfControl,
    mechanismColor,
    remarks,
    motorType,
    selectedItemId: selectedItem?.ROWID,
    shadeDataId: id
  };
  
  if (!userId) {
    // Save form data to localStorage before redirect
    localStorage.setItem('pendingProductData', JSON.stringify(currentFormData));
    console.log("window.location.pathname",window.location.hash);
    localStorage.setItem('redirectAfterLogin', window.location.hash);
    toast.error("Please login to add product to cart");
    navigate("/login");
    return;
  }
  
  if (!selectedItem) {
    toast.error("Please select a product item first");
    return;
  }
  if (!height || !width) {
    toast.error("Please enter height and width");
    return;
  }
  
  // Add width validation before adding to cart
  const widthValue = parseFloat(width);
  const minWidth = getMinWidthInCurrentUnit();
  const maxWidthMM = shadeData?.maxWidth ? parseFloat(shadeData.maxWidth) : null;
  
  // Check min width
  if (widthValue < minWidth) {
    toast.error(`Width must be at least ${minWidth} ${unit}`);
    return;
  }
  
  // Check max width if available
  if (maxWidthMM) {
    let valueInMM = widthValue;
    switch (unit) {
      case "cm":
        valueInMM = widthValue * 10;
        break;
      case "inch":
        valueInMM = widthValue * 25.4;
        break;
    }
    if (valueInMM > maxWidthMM) {
      let maxInCurrentUnit = maxWidthMM;
      switch (unit) {
        case "cm":
          maxInCurrentUnit = (maxWidthMM / 10).toFixed(1);
          break;
        case "inch":
          maxInCurrentUnit = (maxWidthMM / 25.4).toFixed(2);
          break;
        default:
          maxInCurrentUnit = maxWidthMM;
      }
      toast.error(`Width cannot exceed ${maxInCurrentUnit} ${unit}`);
      return;
    }
  }
  
  const selectedMotor = motorData.find((m) => m.motorName === motorType);
  const motorRowId = selectedMotor?.ROWID || "";
  const taxRate = selectedItem?.tax ? Number(selectedItem.tax) : 0;
  const itemPrice = parseFloat(selectedItem?.sellingPrice) || 0;
  const shadePrice = parseFloat(shadeData?.sellingPrice) || 0;
  const sellingPrice = itemPrice + shadePrice;
  const calculatedArea = calculateArea(height, width, unit) || 0;
  const newCartData = {
    accountId: userId || null,
    productId: selectedItem?.ROWID || "",
    quantity: quantity.toString(),
    price: sellingPrice.toString(),
    shadeNo: shadeData?.shadeNo || "Product",
    itemName: selectedItem?.itemName || "",
    image: displayImages[0] || defaultImg,
    height: height.toString(),
    width: width.toString(),
    unit: unit,
    measurements: unit,
    status: "Active",
    motorization: motorization,
    sideOfControl: sideOfControl,
    mechanismColor: mechanismColor,
    remarks: remarks,
    area: calculatedArea.toString(),
    taxRate: taxRate.toString(),
    subtotal: priceBreakdown.subtotal.toString(),
    sellingPricePerUnit: sellingPrice.toString(),
    motorType: motorRowId,
    total: finalPrice.toString(),
  };

  try {
    const response = await addToCartApi(newCartData);
    if (response.data.success) {
      toast.success("Product added to cart successfully");
      const resp = await dispatch(getCartProductsWebuser());
      const carts = resp?.payload?.data || [];
      setCartItems(carts);
      setAddedProducts((prev) => {
        const updated = [...prev, newCartData];
        localStorage.setItem("addedProducts", JSON.stringify(updated));
        return updated;
      });
      onOpen();
    }
  } catch (error) {
    console.error("Error adding product to cart:", error);
    toast.error(error.response?.data?.message || "Failed to add to cart");
  }
};
  useEffect(() => {
    if (!selectedItem || !cartItems?.length) {
      setIsAdded(false);
      return;
    }
    const exists = cartItems.some(
      (item) => String(item.productId) === String(selectedItem.ROWID)
    );
    setIsAdded(exists);
  }, [selectedItem, cartItems]);

  const handleCheckout = () => {
    const userId = localStorage.getItem("UserRowId");
    const cartWithQuantities = cart.map((product) => ({
      ...product,
      quantity: quantities[product.productId] || 1,
    }));
    const cartSubtotal = cart
      .reduce(
        (acc, item) =>
          acc + (item.sellingPrice || item.price || 0) * item.quantity,
        0
      )
      .toFixed(2);
    const shippingRate = 0.18;
    const shippingCost = (parseFloat(cartSubtotal) * shippingRate).toFixed(2);
    const cartTotal = (
      parseFloat(cartSubtotal) + parseFloat(shippingCost)
    ).toFixed(2);
    if (userId) {
      navigate("/shop/checkouts", {
        state: {
          cartItems: cartWithQuantities,
          subtotal: cartSubtotal,
          shippingCost,
          total: cartTotal,
        },
      });
    } else {
      navigate("/login");
      localStorage.setItem("redirect", location.pathname);
    }
  };

  const handleDeleteProduct = async (rowId) => {
    try {
      const resp = await dispatch(deleteCartItemThunk(rowId));
      if (deleteCartItemThunk.fulfilled.match(resp)) {
        toast.success(resp.payload?.message || "Item removed from cart");
        setCartItems((prev) => prev.filter((item) => item.ROWID !== rowId));
        dispatch(getCartProductsWebuser());
      } else {
        toast.error(resp.payload || "Failed to delete item");
      }
    } catch (err) {
      console.error("Delete cart error:", err);
      toast.error("Something went wrong while deleting");
    }
  };

  const { isOpen, onOpen, onClose } = useDisclosure();
  const [addedProducts, setAddedProducts] = useState([]);
  const [isAdded, setIsAdded] = useState(false);

  useEffect(() => {
    const storedProducts = localStorage.getItem("addedProducts");
    if (storedProducts) {
      setAddedProducts(JSON.parse(storedProducts));
    }
  }, []);

  useEffect(() => {
    const fetchUserCart = async () => {
      try {
        setLoading(true);
        if (userId) {
          const resp = await dispatch(getCartProductsWebuser());
          const carts = resp?.payload?.data || [];
          setCartItems(carts);
        } else {
          const guestCart = JSON.parse(localStorage.getItem("guestCart")) || [];
          setCartItems(guestCart);
        }
        setLoading(false);
      } catch (error) {
        setLoading(false);
        console.error("Error fetching cart:", error);
        toast.error("Failed to load cart");
      }
    };
    fetchUserCart();
  }, [dispatch, userId]);

  const [shadesData, setShadesData] = useState([]);
  const getShadeNumberData = useSelector((state) => state?.shade?.shade);

  useEffect(() => {
    dispatch(getShadeNumberList())
      .then((response) => {
        const data = response.payload?.data?.shades || [];
        setShadesData(data);
      })
      .catch((error) => {
        setLoading(false);
        console.error("Error fetching Shades data:", error);
        toast.error("Failed to load shades data");
      })
      .finally(() => {
        setLoading(false);
      });
  }, [dispatch]);

  useEffect(() => {
    if (getShadeNumberData && getShadeNumberData.length > 0) {
      setShadesData(getShadeNumberData);
    }
  }, [getShadeNumberData]);

  const getShadeImageByShadeNo = (shadeNo) => {
    if (!shadesData || shadesData.length === 0 || !shadeNo) {
      return "/fallback-image.jpg";
    }
    const shade = shadesData.find((item) => item.shadeNo === shadeNo);
    if (shade && shade.shadeMedia && shade.shadeMedia.length > 0) {
      return shade.shadeMedia[0];
    }
    return "/fallback-image.jpg";
  };

  const ratingTotal = Object.values(ratingData.breakdown).reduce(
    (sum, count) => sum + count,
    0
  );

  const [colours, setColours] = useState([]);
  const [mechanismColor, setMechanismColor] = useState("white");
  console.log("colours", colours);

  useEffect(() => {
    const fetchColours = async () => {
      setLoading(true);
      try {
        const response = await dispatch(getColoursList());
        const colours = response?.payload?.data?.colours || [];
        setColours(colours);
      } catch (error) {
        console.error("Error fetching colours:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchColours();
  }, [dispatch]);

  const [widthWarning, setWidthWarning] = useState("");

  useEffect(() => {
    if (width && shadeData?.maxWidth) {
      const maxWidthMM = parseFloat(shadeData.maxWidth);
      let valueInMM = parseFloat(width);
      switch (unit) {
        case "cm":
          valueInMM = parseFloat(width) * 10;
          break;
        case "inch":
          valueInMM = parseFloat(width) * 25.4;
          break;
        default:
          valueInMM = parseFloat(width);
      }
      if (valueInMM > maxWidthMM) {
        let maxInNewUnit = maxWidthMM;
        switch (unit) {
          case "cm":
            maxInNewUnit = (maxWidthMM / 10).toFixed(1);
            break;
          case "inch":
            maxInNewUnit = (maxWidthMM / 25.4).toFixed(2);
            break;
          default:
            maxInNewUnit = maxWidthMM;
        }
        setWidth(maxInNewUnit.toString());
        setWidthWarning(
          `Width adjusted to maximum for ${unit} (${maxInNewUnit} ${unit})`
        );
        setTimeout(() => setWidthWarning(""), 3000);
      }
    }
  }, [unit, shadeData?.maxWidth]);

  const getMinWidthInCurrentUnit = () => {
    const MIN_WIDTH_MM = 300; // 300mm minimum
    const MIN_WIDTH_CM = 30;  // 30cm minimum  
    const MIN_WIDTH_INCH = 12; // 12 inches minimum

    switch (unit) {
      case "cm":
        return MIN_WIDTH_CM;
      case "inch":
        return MIN_WIDTH_INCH;
      default: // mm
        return MIN_WIDTH_MM;
    }
  };
  // ─────────── Customize Card (reusable JSX block) ───────────

  const CustomizeCard = (
    <div
      className="w-full max-w-full bg-white shadow-xl overflow-hidden border border-gray-100 sm:border sm:rounded-3xl rounded-none"
      id="customize-section"
      style={{ margin: '0 -6px', width: 'calc(230% + 25px)' }}    >
      {/* Header with gradient */}
      <div className="bg-gradient-to-r from-[#66944b] to-[#7fb073] py-2 px-2 sm:px-4">
        <h2 className="text-2xl font-bold text-white mb-0">
          Customize Your Blinds
        </h2>
        <p className="text-white/80 text-sm mb-0">
          Configure your perfect window covering
        </p>
      </div>

      {/* Main Content - full width on mobile */}
      <div className="w-full bg-white shadow-xl overflow-hidden border border-gray-100 sm:border">
        <div className="p-2 sm:p-4 md:p-5 space-y-3">
          {/* Shade Information Card */}
          <div className="flex flex-col gap-2">
            {/* Shade Number */}
            <div className="flex items-center justify-between bg-white p-2 rounded-lg border border-gray-200">
              <span className="text-xs font-medium text-gray-600">
                Shade Number
              </span>
              <div className="flex items-center gap-2">
                <span className="text-sm font-bold text-[#66944b] bg-[#66944b]/10 px-2 py-0.5 rounded-full">
                  {shadeData?.shadeNo || "N/A"}
                </span>
              </div>
            </div>

            {/* Selected Item Dropdown */}
            {shadeData.items && shadeData.items.length > 0 && (
              <div className="space-y-1">
                <label className="text-xs font-medium text-gray-700 flex items-center gap-1">
                  <span className="text-[#66944b] text-lg leading-none">•</span>{" "}
                  Select Mechanism Type
                </label>
                <select
                  value={selectedItem?.ROWID || ""}
                  onChange={(e) => handleItemChange(e.target.value)}
                  className="w-full border border-gray-300 rounded-lg px-3 py-2.5 text-sm text-gray-700 focus:outline-none focus:ring-1 focus:ring-[#66944b] focus:border-transparent transition bg-white shadow-sm hover:border-[#66944b] cursor-pointer appearance-none"
                  style={{
                    backgroundImage:
                      "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 20 20' stroke='%23666944b'%3E%3Cpath stroke-linecap='round' stroke-linejoin='round' stroke-width='1.5' d='M6 8l4 4 4-4'/%3E%3C/svg%3E\")",
                    backgroundRepeat: "no-repeat",
                    backgroundPosition: "right 0.5rem center",
                    backgroundSize: "1rem",
                  }}
                >
                  {shadeData.items.map((item) => (
                    <option
                      key={item.ROWID}
                      value={item.ROWID}
                      className="py-1 text-sm"
                    >
                      {item.itemName || `Item ${item.ROWID}`}
                    </option>
                  ))}
                </select>
              </div>
            )}
          </div>

          {/* Measurements Card */}
          <div className="flex flex-col gap-2 mt-2">
            {/* Unit Selection */}
            <div className="flex items-center justify-between bg-white p-2 rounded-lg border border-gray-200">
              <div className="flex items-center gap-1">
                <Ruler className="text-[#66944b] text-sm" />
                <span className="text-xs font-medium text-gray-700">Unit:</span>
              </div>
              <div className="flex gap-1 bg-gray-100 p-0.5 rounded-lg">
                {["mm", "cm", "inch"].map((option) => (
                  <label key={option} className="cursor-pointer">
                    <input
                      type="radio"
                      name="unit"
                      value={option}
                      checked={unit === option}
                      onChange={(e) => setUnit(e.target.value)}
                      className="peer sr-only"
                    />
                    <span className="block px-2 py-1 rounded-md text-xs font-medium text-gray-600 peer-checked:bg-[#66944b] peer-checked:text-white peer-checked:shadow-sm transition-all">
                      {option}
                    </span>
                  </label>
                ))}
              </div>
            </div>

            {/* Width & Height Inputs */}
            <div className="grid grid-cols-2 gap-2">
              <div className="space-y-1">
                <label className="text-xs font-medium text-gray-700 flex items-center gap-1">
                  <span className="text-[#66944b] text-xs">↔️</span> Width
                </label>
                <div className="relative">
                  {/* <input
                    type="number"
                    value={width}
                    onChange={(e) => {
                      const newValue = e.target.value;
                      const maxWidthMM = shadeData?.maxWidth
                        ? parseFloat(shadeData.maxWidth)
                        : null;
                      if (newValue && maxWidthMM) {
                        let valueInMM = parseFloat(newValue);
                        switch (unit) {
                          case "cm":
                            valueInMM = parseFloat(newValue) * 10;
                            break;
                          case "inch":
                            valueInMM = parseFloat(newValue) * 25.4;
                            break;
                          default:
                            valueInMM = parseFloat(newValue);
                        }
                        if (valueInMM > maxWidthMM) {
                          let maxInCurrentUnit = maxWidthMM;
                          switch (unit) {
                            case "cm":
                              maxInCurrentUnit = (maxWidthMM / 10).toFixed(1);
                              break;
                            case "inch":
                              maxInCurrentUnit = (maxWidthMM / 25.4).toFixed(2);
                              break;
                            default:
                              maxInCurrentUnit = maxWidthMM;
                          }
                          switch (unit) {
                            case "cm":
                              setWidth((maxWidthMM / 10).toString());
                              break;
                            case "inch":
                              setWidth((maxWidthMM / 25.4).toFixed(2));
                              break;
                            default:
                              setWidth(maxWidthMM.toString());
                          }
                          setWidthWarning(
                            `Maximum allowed width is ${maxInCurrentUnit} ${unit}`
                          );
                          setTimeout(() => setWidthWarning(""), 3000);
                        } else {
                          setWidth(newValue);
                          setWidthWarning("");
                        }
                      } else {
                        setWidth(newValue);
                        setWidthWarning("");
                      }
                    }}
                    className={`w-full border ${widthWarning ? "border-red-300" : "border-gray-300"
                      } rounded-lg pl-2 pr-8 py-2 text-sm text-gray-700 focus:outline-none focus:ring-1 focus:ring-[#66944b] focus:border-transparent transition bg-white shadow-sm hover:border-[#66944b]`}
                    placeholder="0.00"
                    min="0"
                    step={unit === "inch" ? "0.01" : "1"}
                  /> */}
                  <input
                    type="number"
                    value={width}
                    onChange={(e) => {
                      const newValue = e.target.value;

                      // Just set the value without any auto-correction
                      setWidth(newValue);

                      // Clear any existing warning
                      setWidthWarning("");
                    }}
                    onBlur={(e) => {
                      // Validate on blur (when user leaves the field)
                      const currentValue = e.target.value;

                      if (currentValue) {
                        const numValue = parseFloat(currentValue);
                        const minWidth = getMinWidthInCurrentUnit();
                        const maxWidthMM = shadeData?.maxWidth ? parseFloat(shadeData.maxWidth) : null;

                        let warningMessage = "";

                        // Check min width
                        if (numValue < minWidth) {
                          warningMessage = `Minimum width is ${minWidth} ${unit}`;
                        }

                        // Check max width if available
                        if (maxWidthMM && !warningMessage) {
                          let valueInMM = numValue;
                          switch (unit) {
                            case "cm":
                              valueInMM = numValue * 10;
                              break;
                            case "inch":
                              valueInMM = numValue * 25.4;
                              break;
                            default:
                              valueInMM = numValue;
                          }

                          if (valueInMM > maxWidthMM) {
                            let maxInCurrentUnit = maxWidthMM;
                            switch (unit) {
                              case "cm":
                                maxInCurrentUnit = (maxWidthMM / 10).toFixed(1);
                                break;
                              case "inch":
                                maxInCurrentUnit = (maxWidthMM / 25.4).toFixed(2);
                                break;
                              default:
                                maxInCurrentUnit = maxWidthMM;
                            }
                            warningMessage = `Maximum allowed width is ${maxInCurrentUnit} ${unit}`;
                          }
                        }

                        if (warningMessage) {
                          setWidthWarning(warningMessage);
                          setTimeout(() => setWidthWarning(""), 3000);
                        }
                      }
                    }}
                    className={`w-full border ${widthWarning ? "border-red-300" : "border-gray-300"} rounded-lg pl-2 pr-8 py-2 text-sm text-gray-700 focus:outline-none focus:ring-1 focus:ring-[#66944b] focus:border-transparent transition bg-white shadow-sm hover:border-[#66944b]`}
                    placeholder="0.00"
                    step={unit === "inch" ? "0.01" : "1"}
                  />
                  <div className="absolute right-2 top-1/2 -translate-y-1/2 bg-gray-100 px-1.5 py-0.5 rounded text-[10px] font-medium text-gray-600">
                    {unit}
                  </div>
                </div>

              {widthWarning && (
                <div className="text-[10px] text-red-500 mt-0.5 flex items-center gap-1">
                  <span>⚠️</span>
                  <span>{widthWarning}</span>
                </div>
              )}

              {/* {shadeData?.maxWidth && (
                  <div className="text-[10px] text-gray-500 mt-0.5 flex justify-between">
                    <span>
                      Max:{" "}
                      {unit === "mm"
                        ? `${shadeData.maxWidth} mm`
                        : unit === "cm"
                          ? `${(parseFloat(shadeData.maxWidth) / 10).toFixed(1)} cm`
                          : unit === "inch"
                            ? `${(parseFloat(shadeData.maxWidth) / 25.4).toFixed(2)} inch`
                            : ""}
                    </span>
                    {width &&
                      parseFloat(width) > 0 &&
                      shadeData?.maxWidth &&
                      (() => {
                        let currentInMM = parseFloat(width);
                        switch (unit) {
                          case "cm":
                            currentInMM = parseFloat(width) * 10;
                            break;
                          case "inch":
                            currentInMM = parseFloat(width) * 25.4;
                            break;
                        }
                        const maxMM = parseFloat(shadeData.maxWidth);
                        return (
                          <span
                            className={
                              currentInMM > maxMM
                                ? "text-red-500"
                                : "text-green-500"
                            }
                          >
                            {currentInMM > maxMM ? "Exceeds limit" : "Within limit"}
                          </span>
                        );
                      })()}
                  </div>
                )} */}
              {/* Display min width */}
              {shadeData?.maxWidth && (
                <div className="text-[10px] text-gray-500 mt-0.5 flex justify-between">
                  <div className="flex gap-2">
                    <span>
                      Min:{" "}
                      {unit === "mm"
                        ? "300 mm"
                        : unit === "cm"
                          ? "30 cm"
                          : unit === "inch"
                            ? "12 inch"
                            : ""}
                    </span>
                    <span>
                      Max:{" "}
                      {unit === "mm"
                        ? `${shadeData.maxWidth} mm`
                        : unit === "cm"
                          ? `${(parseFloat(shadeData.maxWidth) / 10).toFixed(1)} cm`
                          : unit === "inch"
                            ? `${(parseFloat(shadeData.maxWidth) / 25.4).toFixed(2)} inch`
                            : ""}
                    </span>
                  </div>
                  {width &&
                    parseFloat(width) > 0 &&
                    shadeData?.maxWidth &&
                    (() => {
                      let currentInMM = parseFloat(width);
                      switch (unit) {
                        case "cm":
                          currentInMM = parseFloat(width) * 10;
                          break;
                        case "inch":
                          currentInMM = parseFloat(width) * 25.4;
                          break;
                      }
                      const maxMM = parseFloat(shadeData.maxWidth);
                      const minMM = 300;
                      return (
                        <span className={currentInMM > maxMM || currentInMM < minMM ? "text-red-500" : "text-green-500"}>
                          {currentInMM > maxMM
                            ? "Exceeds max limit"
                            : currentInMM < minMM
                              ? "Below min limit"
                              : "Within limits"}
                        </span>
                      );
                    })()}
                </div>
              )}
            </div>

            <div className="space-y-1">
              <label className="text-xs font-medium text-gray-700 flex items-center gap-1">
                <span className="text-[#66944b] text-xs">↕️</span> Height
              </label>
              <div className="relative">
                <input
                  type="number"
                  value={height}
                  onChange={(e) => setHeight(e.target.value)}
                  className="w-full border border-gray-300 rounded-lg pl-2 pr-8 py-2 text-sm text-gray-700 focus:outline-none focus:ring-1 focus:ring-[#66944b] focus:border-transparent transition bg-white shadow-sm hover:border-[#66944b]"
                  placeholder="0.00"
                  min="0"
                  step={unit === "inch" ? "0.01" : "1"}
                />
                <div className="absolute right-2 top-1/2 -translate-y-1/2 bg-gray-100 px-1.5 py-0.5 rounded text-[10px] font-medium text-gray-600">
                  {unit}
                </div>
              </div>
            </div>
          </div>

          {/* Area Display */}
          {area > 0 && (
            <div className="flex items-center justify-end">
              <span className="text-xs font-medium text-gray-600 pe-1">
                Area will be
              </span>
              <span className="text-sm font-bold text-[#66944b]">
                {`${area.toFixed(2)}`} sq m
              </span>
            </div>
          )}
        </div>

        {/* Style & Controls Card */}
        <div className="flex flex-col gap-2">
          {/* Motorization */}
          <div className="grid grid-cols-2 gap-2">
            <div>
              <label className="text-xs font-medium text-gray-700 block mb-1">
                Motorization
              </label>
              <div className="flex gap-1 bg-white p-0.5 rounded-lg border border-gray-200 w-fit">
                {["No", "Yes"].map((option) => (
                  <label key={option} className="cursor-pointer">
                    <input
                      type="radio"
                      name="motorization"
                      value={option}
                      checked={motorization === option}
                      onChange={(e) => setMotorization(e.target.value)}
                      className="peer sr-only"
                    />
                    <span
                      className={`block px-3 py-1 rounded-md text-xs font-medium transition-all ${motorization === option
                        ? "bg-[#66944b] text-white shadow-sm"
                        : "text-gray-600 hover:bg-gray-100"
                        }`}
                    >
                      {option}
                    </span>
                  </label>
                ))}
              </div>
            </div>

            {/* Motor Type - conditional */}
            {motorization === "Yes" && (
              <div>
                <label className="text-xs font-medium text-gray-700 block mb-1">
                  Motor Type
                </label>
                <select
                  value={motorType}
                  onChange={(e) => setMotorType(e.target.value)}
                  className="w-full border border-gray-300 rounded-lg px-2 py-1.5 text-xs text-gray-700 focus:outline-none focus:ring-1 focus:ring-[#66944b] focus:border-transparent transition bg-white shadow-sm hover:border-[#66944b]"
                >
                  <option value="" disabled={motorType !== ""}>
                    -- Select Motor --
                  </option>
                  {motorData
                    .filter((motor) => {
                      const motorSubCategories = JSON.parse(
                        motor.subCategory || "[]"
                      );
                      return (
                        selectedItem &&
                        motorSubCategories.includes(selectedItem.subCategory)
                      );
                    })
                    .map((motor) => (
                      <option key={motor.ROWID} value={motor.motorName}>
                        {motor.motorName} {motor.motorPrice}
                      </option>
                    ))}
                </select>
                {motorization === "Yes" &&
                  selectedItem &&
                  motorData.filter((motor) => {
                    const motorSubCategories = JSON.parse(
                      motor.subCategory || "[]"
                    );
                    return motorSubCategories.includes(
                      selectedItem.subCategory
                    );
                  }).length === 0 && (
                    <p className="text-xs text-red-500 mt-1">
                      No motors available for this mechanism type
                    </p>
                  )}
              </div>
            )}
          </div>

          {/* Side of Control & Mechanism Color */}
          <div className="grid grid-cols-2 gap-2">
            <div>
              <label className="text-xs font-medium text-gray-700 block mb-1">
                Side of Control
              </label>
              <div className="flex gap-1 bg-white p-0.5 rounded-lg border border-gray-200 w-fit">
                {["Left", "Right"].map((option) => (
                  <label key={option} className="cursor-pointer">
                    <input
                      type="radio"
                      name="sideOfControl"
                      value={option}
                      checked={sideOfControl === option}
                      onChange={(e) => setSideOfControl(e.target.value)}
                      className="peer sr-only"
                    />
                    <span
                      className={`block px-3 py-1 rounded-md text-xs font-medium transition-all ${sideOfControl === option
                        ? "bg-[#66944b] text-white shadow-sm"
                        : "text-gray-600 hover:bg-gray-100"
                        }`}
                    >
                      {option}
                    </span>
                  </label>
                ))}
              </div>
            </div>

            <div>
              <label className="text-xs font-medium text-gray-700 block mb-1">
                Mechanism Colour
              </label>
              <select
                value={mechanismColor}
                onChange={(e) => setMechanismColor(e.target.value)}
                className="w-full border border-gray-300 rounded-lg px-2 py-1.5 text-xs text-gray-700 focus:outline-none focus:ring-1 focus:ring-[#66944b] focus:border-transparent transition bg-white shadow-sm hover:border-[#66944b]"
              >
                <option value="white">White</option>
                {colours.map((item) => (
                  <option key={item.ROWID} value={item.colour}>
                    {item.colour}
                  </option>
                ))}
              </select>
            </div>
          </div>

          {/* Remarks */}
          <div>
            <label className="text-xs font-medium text-gray-700 block mb-1">
              Remarks / Special Requests
            </label>
            <textarea
              value={remarks}
              onChange={(e) => setRemarks(e.target.value)}
              className="w-full border border-gray-300 rounded-lg px-2 py-1.5 text-xs text-gray-700 focus:outline-none focus:ring-1 focus:ring-[#66944b] focus:border-transparent transition bg-white shadow-sm hover:border-[#66944b] resize-none"
              placeholder="Special requests..."
              rows={3}
            />
          </div>
        </div>

        {/* Price & Checkout Card */}
        <div className="flex flex-col gap-2">
          {/* Quantity */}
          <div className="flex items-center justify-between bg-white p-2 rounded-lg border border-gray-200">
            <span className="text-xs font-medium text-gray-700">Quantity</span>
            <div className="flex items-center w-32 border border-[#dfe9da] rounded-lg bg-background-light">
              <button
                className="px-3 py-1.5 hover:bg-[#dfe9da] rounded-l-lg transition-colors"
                onClick={handleDecrease}
              >
                -
              </button>
              <input
                className="w-full text-center border-none bg-transparent focus:ring-0 font-bold text-sm"
                readOnly
                type="number"
                value={quantity}
              />
              <button
                className="px-3 py-1.5 hover:bg-[#dfe9da] rounded-r-lg transition-colors"
                onClick={handleIncrease}
              >
                +
              </button>
            </div>
          </div>

          {/* Total Price */}
          <div className="flex items-center justify-between bg-[#66944b]/5 p-2 rounded-lg border border-[#66944b]/20">
            <span className="text-xs font-semibold text-gray-700">Total</span>
            <span className="text-lg font-bold text-[#66944b]">
              ₹{finalPrice.toFixed(2)}
            </span>
          </div>

          {/* Add to Cart Button */}
          <button
            onClick={handleAddToCart}
            disabled={!selectedItem || !height || !width}
            className={`w-full flex items-center justify-center gap-2 py-3 rounded-lg text-white font-semibold text-sm transition-all ${!selectedItem || !height || !width
              ? "bg-gray-300 cursor-not-allowed"
              : isAdded
                ? "bg-gradient-to-r from-[#661e33] to-[#8a2a45] hover:shadow-sm"
                : "bg-gradient-to-r from-[#66944b] to-[#7fb073] hover:shadow-sm"
              }`}
          >
            <FaCartPlus className="text-sm" />
            {!selectedItem
              ? "Select Item First"
              : !height || !width
                ? "Enter Dimensions"
                : isAdded
                  ? "Add Again"
                  : "Add to Cart"}
          </button>

          {/* Error Message */}
          {(!height || !width) && selectedItem && (
            <div className="flex items-center gap-1 text-red-500">
              <span className="text-xs">⚠️</span>
              <p className="text-[12px] mb-0 font-medium">
                Enter height & width
              </p>
            </div>
          )}
        </div>
      </div>
    </div>
    </div >
  );
// ─────────── Customer Reviews Section (Reusable Component) ───────────
// 
//  const CustomerReviews = (
//     <div className="w-full">
//       <p className="text-center font-bold text-xl mb-6">Customer Review</p>
//       <div className="flex flex-col gap-6 w-full bg-white p-6 rounded-xl shadow-md">
//         {/* Ratings Breakdown */}
//         <div className="w-full flex flex-col md:flex-row gap-6 md:gap-10">
//           {/* Left side - Rating Summary */}
//           <div className="md:w-1/3">
//             <div className="text-4xl font-bold text-gray-800 flex items-center gap-1">
//               {ratingData.average}
//               <FaStar className="text-yellow-500" />
//             </div>
//             <p className="text-gray-500 text-sm mt-1">
//               {ratingData.totalRatings} Ratings & {ratingData.totalReviews}{" "}
//               Reviews
//             </p>
//           </div>

//           {/* Right side - Rating Breakdown */}
//           <div className="md:w-2/3 space-y-2">
//             {Object.entries(ratingData.breakdown)
//               .sort((a, b) => b[0] - a[0])
//               .map(([star, count]) => {
//                 const percentage = (count / ratingTotal) * 100;
//                 const barColor =
//                   star === "1"
//                     ? "bg-red-500"
//                     : star === "2"
//                     ? "bg-orange-400"
//                     : star === "3"
//                     ? "bg-yellow-500"
//                     : star === "4"
//                     ? "bg-green-400"
//                     : "bg-green-600";
//                 return (
//                   <div
//                     key={star}
//                     className="flex items-center gap-2 text-sm"
//                   >
//                     <div className="w-5 text-sm text-gray-700">{star}</div>
//                     <FaStar className="text-yellow-500 text-xs" />
//                     <div className="flex-1 bg-gray-200 rounded-full h-2 overflow-hidden">
//                       <div
//                         className={`${barColor} h-full rounded-full`}
//                         style={{ width: `${percentage}%` }}
//                       />
//                     </div>
//                     <div className="w-12 text-right text-gray-500 text-xs">
//                       {count >= 1000
//                         ? `${(count / 1000).toFixed(1)}k`
//                         : count}
//                     </div>
//                   </div>
//                 );
//               })}
//           </div>
//         </div>

//         {/* Review Cards */}
//         <div className="w-full">
//           {reviews.map((review, idx) => (
//             <div
//               key={idx}
//               className="border rounded-lg p-4 bg-gray-50 shadow-sm flex flex-col space-y-2"
//             >
//               <div className="flex items-center justify-start">
//                 <div className="flex items-center gap-2">
//                   <span className="text-sm font-semibold text-gray-800">
//                     {review.name}
//                   </span>
//                   <span className="inline-flex items-center px-2 py-0.5 text-xs font-medium bg-blue-100 rounded">
//                     {review.rating}{" "}
//                     <FaStar className="text-yellow-500 ml-1" />
//                   </span>
//                 </div>
//               </div>
//               <div>
//                 <p className="text-sm text-gray-600">
//                   {review.content}
//                 </p>
//               </div>
//             </div>
//           ))}
//         </div>
//       </div>
//     </div>
//   ); 
// const CustomerReviews = (
//   <div
//     className="w-full max-w-full bg-white shadow-xl overflow-hidden border border-gray-100 sm:border sm:rounded-3xl rounded-none"
//     style={{ margin: '0 -6px', width: 'calc(100% + 12px)' }}
//   >
//     {/* Header with gradient - matching CustomizeCard style */}
//     <div className="bg-gradient-to-r from-[#66944b] to-[#7fb073] py-2 px-2 sm:px-4">
//       <h2 className="text-2xl font-bold text-white mb-0">
//         Customer Reviews
//       </h2>
//       <p className="text-white/80 text-sm mb-0">
//         What our customers say
//       </p>
//     </div>

//     {/* Main Content - full width on mobile */}
//     <div className="w-full bg-white shadow-xl overflow-hidden border border-gray-100 sm:border">
//       <div className="p-2 sm:p-4 md:p-5 space-y-3">
//         {/* Ratings Breakdown */}
//         <div className="w-full flex flex-col md:flex-row gap-6 md:gap-10">
//           {/* Left side - Rating Summary */}
//           <div className="md:w-1/3">
//             <div className="text-4xl font-bold text-gray-800 flex items-center gap-1">
//               {ratingData.average}
//               <FaStar className="text-yellow-500" />
//             </div>
//             <p className="text-gray-500 text-sm mt-1">
//               {ratingData.totalRatings} Ratings & {ratingData.totalReviews}{" "}
//               Reviews
//             </p>
//           </div>

//           {/* Right side - Rating Breakdown */}
//           <div className="md:w-2/3 space-y-2">
//             {Object.entries(ratingData.breakdown)
//               .sort((a, b) => b[0] - a[0])
//               .map(([star, count]) => {
//                 const percentage = (count / ratingTotal) * 100;
//                 const barColor =
//                   star === "1"
//                     ? "bg-red-500"
//                     : star === "2"
//                       ? "bg-orange-400"
//                       : star === "3"
//                         ? "bg-yellow-500"
//                         : star === "4"
//                           ? "bg-green-400"
//                           : "bg-green-600";
//                 return (
//                   <div
//                     key={star}
//                     className="flex items-center gap-2 text-sm"
//                   >
//                     <div className="w-5 text-sm text-gray-700">{star}</div>
//                     <FaStar className="text-yellow-500 text-xs" />
//                     <div className="flex-1 bg-gray-200 rounded-full h-2 overflow-hidden">
//                       <div
//                         className={`${barColor} h-full rounded-full`}
//                         style={{ width: `${percentage}%` }}
//                       />
//                     </div>
//                     <div className="w-12 text-right text-gray-500 text-xs">
//                       {count >= 1000
//                         ? `${(count / 1000).toFixed(1)}k`
//                         : count}
//                     </div>
//                   </div>
//                 );
//               })}
//           </div>
//         </div>

//         {/* Review Cards */}
//         <div className="w-full">
//           {reviews.map((review, idx) => (
//             <div
//               key={idx}
//               className="border rounded-lg p-4 bg-gray-50 shadow-sm flex flex-col space-y-2 mb-2 last:mb-0"
//             >
//               <div className="flex items-center justify-start">
//                 <div className="flex items-center gap-2">
//                   <span className="text-sm font-semibold text-gray-800">
//                     {review.name}
//                   </span>
//                   <span className="inline-flex items-center px-2 py-0.5 text-xs font-medium bg-blue-100 rounded">
//                     {review.rating}{" "}
//                     <FaStar className="text-yellow-500 ml-1" />
//                   </span>
//                 </div>
//               </div>
//               <div>
//                 <p className="text-sm text-gray-600">
//                   {review.content}
//                 </p>
//               </div>
//             </div>
//           ))}
//         </div>
//       </div>
//     </div>
//   </div>
// );



return isLoading ? (
  <div className="flex items-center justify-center bg-gradient-to-b from-[#fbfbfb] to-[#f7f7f7] h-full">
    <Shoploader />
    <p className="text-gray-600">Loading product details...</p>
  </div>
) : (
  <motion.div
    initial={{ opacity: 0, y: 50 }}
    animate={{ opacity: 1, y: 0 }}
    transition={{ duration: 0.4 }}
    className="mt-[50px] container"
  >
    <div className="w-full px-0  lg:px-8 py-1 flex flex-col justify-between">
      {/* Back Button */}
      <div className="w-full !pl-14 md:pl-2 md:mt-0 py-[0px]">
        <Link to="/shop">
          <FaArrowLeft className="mt-3 -ml-12 md:-ml-12" size="20px" />
        </Link>
      </div>

      {/* ─────────── Main flex row ─────────── */}
      <div className="flex flex-col lg:flex-row gap-6 lg:gap-16 items-start justify-center mx-auto mt-10 !py-0 w-full mb-3">
        {/* Left column – image + thumbnails + customer reviews (desktop) */}
        <div className="w-full w-[90%] lg:w-[60%] flex flex-col gap-6">
          {/* Tags */}
          {shadeData?.tagsId && (
            <div
              className="px-0 sm:px-2"
              style={{ marginBottom: "-57px", zIndex: "2" }}
            >
              <div className="flex flex-wrap gap-2">
                {(() => {
                  try {
                    const tagIds = JSON.parse(shadeData.tagsId);
                    if (!Array.isArray(tagIds)) return null;
                    return tagIds.map((id, index) => {
                      const matchingTag = getTagsData?.tagMasters?.find(
                        (tag) => tag.tagMasters.ROWID === id
                      );
                      return matchingTag ? (
                        <span
                          key={index}
                          className="px-3 py-1 bg-blue-100 text-blue-800 text-sm font-medium rounded-full"
                        >
                          {matchingTag.tagMasters.tagName}
                        </span>
                      ) : null;
                    });
                  } catch (error) {
                    console.error("Error parsing tagsId:", error);
                    return null;
                  }
                })()}
              </div>
            </div>
          )}

          <motion.div layout className="w-full flex gap-1 mt-2">
            <div className="flex flex-col justify-start gap-2 sm:gap-6 md:gap-4 pb-2">
              {(displayImages?.length
                ? displayImages.slice(0, 4)
                : Array(4).fill(null)
              ).map((img, idx) => (
                <button
                  key={idx}
                  onClick={() => img && changeImage(idx)}
                  disabled={!img}
                  className={`w-16 h-16 sm:w-18 sm:h-18 md:w-20 md:h-20 border-2 rounded-lg overflow-hidden transition ${imageIndex === idx && img
                    ? "border-[#011638]"
                    : "border-gray-200"
                    }`}
                >
                  {img ? (
                    <img
                      src={img}
                      alt={`thumb-${idx}`}
                      className="w-full h-full object-contain"
                    />
                  ) : (
                    <div className="w-full h-full bg-gray-200" />
                  )}
                </button>
              ))}
            </div>
            {/* MAIN IMAGE */}
            <div className="relative left-1/2 -translate-x-1/2 w-[135%] min-[480px]:w-[85%] sm:w-[calc(70%+4rem)] md:w-[calc(100%+6rem)] min-w-[280px] max-w-[500px] sm:max-w-none bg-gray-100 rounded-xl overflow-hidden aspect-[4/3]">
              {displayImages?.length ? (
                <img
                  src={displayImages[imageIndex]}
                  alt={`Shade ${shadeData?.shadeNo || "product"}`}
                  className="w-full h-full object-cover transition-transform duration-300 ease-in-out hover:scale-105"
                />
              ) : (
                <div className="w-full h-full bg-gray-200 rounded-xl flex items-center justify-center">
                  <span className="text-gray-400">No image available</span>
                </div>
              )}
            </div>

            {/* THUMBNAILS */}
            {/* <div className="flex gap-3 overflow-x-auto pb-2 scrollbar-hide justify-start">
                {(displayImages?.length
                  ? displayImages
                  : Array(4).fill(null)
                ).map((img, idx) => (
                  <button
                    key={idx}
                    onClick={() => img && changeImage(idx)}
                    disabled={!img}
                    className={`w-16 h-16 sm:w-18 sm:h-18 md:w-20 md:h-20 flex-shrink-0 border-2 rounded-lg overflow-hidden transition ${
                      imageIndex === idx && img
                        ? "border-[#011638]"
                        : "border-gray-200"
                    }`}
                  >
                    {img ? (
                      <img
                        src={img}
                        alt={`thumb-${idx}`}
                        className="w-full h-full object-contain"
                      />
                    ) : (
                      <div className="w-full h-full bg-gray-200" />
                    )}
                  </button>
                ))}
              </div>
              
            </motion.div> */}

            
          </motion.div>

          {/* Customer Reviews - Desktop View (visible only on lg screens and above) */}
          {/* <div className="hidden lg:block mt-8">
              {CustomerReviews}
            </div> */}
        </div>

        {/* ─────────── Right column – details + customize card ─────────── */}
        <div className="w-full lg:w-[40%] flex flex-col gap-4">
          <div className="w-full text-left">
            <Heading
              className="lg:text-[2.5rem] text-left pb-0 relative !left-[-5rem] sm:!left-[-16rem] md:!left-[-16rem] lg:!left-[-3rem]"
              subText={`Shade ${shadeData?.shadeNo || "Product"}`}
            />
            <p className="text-xl sm:text-2xl font-semibold text-gray-900">
              ₹{(
                (parseFloat(selectedItem?.sellingPrice || 0)) +
                (parseFloat(shadeData?.sellingPrice || 0))
              ).toFixed(2)} per sq m
            </p>
            {/* Description */}
            <p className="text-sm sm:text-base text-gray-700 mb-2 sm:mb-4">
              {shadeData?.description}
            </p>
          </div>

          {/* Specifications Grid */}
          <div className="px-0 sm:px-2">
            {(() => {
              const specifications = [
                { label: "Description", value: shadeData?.sellingDescription || "N/A" },
                { label: "Fabric", value: shadeData?.fabric || "N/A" },
                { label: "GSM", value: shadeData?.gsm || "N/A" },
                { label: "UV Blockage", value: shadeData?.uvBlockage || "N/A" },
                // {
                //   label: "Openness Factor",
                //   value: shadeData?.opennessFactor || "N/A",
                // },
                { label: "Green Guard", value: shadeData?.greenGuard || "N/A" },
                // {
                //   label: "Available Stock",
                //   value: selectedItem?.availableStock || "0",
                // },
              ];
              return (
                <>
                  {/* Desktop/Tablet view */}
                  <div className="hidden sm:block">
                    {specifications.map((spec, index) => (
                      <div
                        key={index}
                        className="grid grid-cols-2 border-b border-gray-100"
                      >
                        <dt className="text-sm sm:text-base text-gray-900 font-medium">
                          {spec.label}
                        </dt>
                        <dd className="text-sm sm:text-base">{spec.value}</dd>
                      </div>
                    ))}
                  </div>
                  {/* Mobile view */}
                  <div className="sm:hidden space-y-0">
                    {specifications.map((spec, index) => (
                      <div
                        key={index}
                        className="flex justify-between items-center py-1 border-b border-gray-100"
                      >
                        <dt className="text-sm text-gray-600 font-medium">
                          {spec.label}
                        </dt>
                        <dd className="text-sm text-gray-900 font-semibold">
                          {spec.value}
                        </dd>
                      </div>
                    ))}
                  </div>
                </>
              );
            })()}
          </div>


          {/* ✅ Customize Card — directly below specs, no gap */}
          {CustomizeCard}
        </div>
        {/* end right column */}
      </div>
    </div>

    {/* Customer Reviews Section — Mobile & Tablet View (visible only on screens below lg) */}
    <div className="lg:hidden px-8 mt-8">
      {/* {CustomerReviews} */}
    </div>

    {/* Cart Modal */}
    <Modal isOpen={isOpen} onClose={onClose} size={{ base: "xs", md: "xl" }} isCentered>
      <ModalOverlay />
      <ModalContent borderRadius="xl" p={1}>
        <ModalHeader className="text-lg font-bold text-[#233857]">
          Added to Cart
        </ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          {cartItems.length === 0 ? (
            <p className="text-gray-500 text-center">No Products Added Yet</p>
          ) : (
            cartItems.map((p, idx) => {
              const shadeImage = getShadeImageByShadeNo(p.shadeNo);
              return (
                <div
                  key={p.ROWID || idx}
                  className="flex items-center gap-4 border-b border-gray-200 py-2"
                >
                  <img
                    src={shadeImage}
                    alt={p.shadeNo || "Product"}
                    className="w-20 h-20 object-contain border rounded-lg"
                    onError={(e) => {
                      e.target.src = defaultImg;
                    }}
                  />
                  <div className="flex-1">
                    <div className="flex justify-between">
                      <div className="flex flex-col">
                        <h4 className="font-semibold text-gray-800 mt-1">
                          Shade {p.shadeNo || "Product"}
                        </h4>
                        <p className="text-sm text-gray-600 mb-1">
                          Qty: {p.quantity} | {p.height} {p.measurements} ×{" "}
                          {p.width} {p.measurements}
                        </p>
                        <p className="font-medium text-[#66944b] mb-2">
                          <span className="text-black">Total: </span> ₹
                          {Number(p.total).toFixed(2)}
                        </p>
                      </div>
                      <button
                        className="py-0.5 ml-auto"
                        onClick={() => handleDeleteProduct(p.ROWID)}
                      >
                        <Trash2 color="red" />
                      </button>
                    </div>
                  </div>
                </div>
              );
            })
          )}
        </ModalBody>
        <ModalFooter className="flex-col md:!flex-row justify-between gap-3">
          <button
            className="w-full flex items-center justify-center gap-2 bg-[#66944b] text-white font-semibold px-2 py-2 rounded-xl text-lg transition border border-transparent hover:bg-white hover:!text-[#66944b] hover:!border-[#66944b] whitespace-nowrap"
            onClick={() => {
              onClose();
              navigate("/shop");
            }}
          >
            Continue Shopping
          </button>
          <button
            className="w-full flex items-center justify-center gap-2 bg-[#66944b] text-white font-semibold px-2 py-2 rounded-xl text-lg transition border border-transparent hover:bg-white hover:!text-[#66944b] hover:!border-[#66944b] whitespace-nowrap"
            onClick={() => {
              onClose();
            }}
          >
            Continue With Same Product
          </button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  </motion.div>
);
};

export default ProductDetailPage;